<template>
  <div class="FilteredData">
    <Card :title="$t('business.total')">
      <div class="Content">
        <p v-if="isEmpy" class="NA" v-text=" 'N / A' " />
        <p v-else v-text="this.selectedSector.amount" />
      </div>
    </Card>
    <Card :title="this.title">
      <VariantDisplay :total="200" :changed="0" />
    </Card>
  </div>
</template>

<script>
import { VariantDisplay } from 'daas-components';

import { Card } from '@/components';
import { LAST_THIRTY_DAYS } from '@/constants';
import EventBus from '@/utils/eventBus';

export default {
  name: 'FilteredBusinessData',
  data() {
    return {
      title: this.$t(`date-picker.${LAST_THIRTY_DAYS}`),
      selectedSector: {},
    };
  },
  computed: {
    isEmpy() {
      return !this.selectedSector.amount
    },
  },
  components: { Card, VariantDisplay },
  mounted() {
    EventBus.$on('ON_DATE_BUSINESS', value => {
      this.selectedSector = value;
    });
  },
};
</script>

<style lang="scss">
.FilteredData {
  height: 10%;
  display: flex;
  justify-content: center;
  .Card {
    height: 100%;
    margin: rem(10);
    padding-left: rem(20);
    padding-right: rem(20);
    .Content {
      margin-left: rem(15);
      font-size: rem(35);
      font-weight: 700;
    }
    .VariantDisplay {
      font-size: rem(35);
      font-weight: 700;
      display: flex;
    }
  }
}
</style>
